export interface EnvConfig {
    authIssuer: string;
    authClientId: string;
    authScope: string;
    useMockData: boolean;
    assetManagementApiBaseUrl: string;
    publicApiBaseUrl: string;
    publicAPIVersion: string;
    publicAPIClientType: string;
    logging?: boolean;
}

const qaClientId = "_HFBsV9pFZfTmCQjFEJfTvfETFEa";
const prodClientId = "T4gVl526wzf8Fu6oGyKSDIlTflAa";

const baseConfig = {
    publicAPIVersion: "4.23",
    publicAPIClientType: "ServiceApp",
    assetManagementApiBaseUrl: "https://api-s.trumpf.com",
    authIssuer: "https://identity-s.trumpf.com",
    authClientId: qaClientId,
    authScope: "openid oicd"
};

const envConfigs: {
    [key: string]: EnvConfig;
} = {
    dev: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.qa.mytbs.trumpf.com",
        useMockData: false,
        logging: true
    },
    devLegacy: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.mytrumpf.com.qa.tru",
        useMockData: false,
        logging: true
    },
    qa: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.qa.mytbs.trumpf.com",
        useMockData: false
    },
    qaLegacy: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.mytrumpf.com.qa.tru",
        useMockData: false
    },
    prod: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.mytbs.trumpf.com",
        assetManagementApiBaseUrl: "https://api-p.trumpf.com",
        authIssuer: "https://identity.trumpf.com",
        authClientId: prodClientId,
        useMockData: false
    },
    prodLegacy: {
        ...baseConfig,
        publicApiBaseUrl: "https://api.mytrumpf.com",
        assetManagementApiBaseUrl: "https://api-p.trumpf.com",
        authIssuer: "https://identity.trumpf.com",
        authClientId: prodClientId,
        useMockData: false
    }
};
let env: string = "prod";
export const authClientName = "service-cases";

/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
export const getEnvConfig = (environment?: string): EnvConfig => {
    return envConfigs[environment || env];
};

/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
export const setEnv = (environment: string) => {
    if (!envConfigs[environment]) {
        // eslint-disable-next-line no-console
        console.error(`Environment ${environment} not found`);
        return;
    }
    env = environment;
};
